import * as api from "app/api/workstations"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./templateWorkstationAvailabilities.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getTemplateWorkstationAvailabilities(
  action: actions.GetTemplateWorkstationAvailabilitiesAction,
): SagaIterator {
  try {
    const { payload } = action
    const response = yield call(api.getTemplateWorkstationAvailabilities, payload)
    yield put(actions.getTemplateWorkstationAvailabilitiesSuccess(response.data))
  } catch (e) {
    yield put(actions.getTemplateWorkstationAvailabilitiesFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* workstationsSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getTemplateWorkstationAvailabilities)
}
